import m from "../../geodata/es2015/maltaLow";
window.am4geodata_maltaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maltaLow.js
// module id = null
// module chunks = 